// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user_referrals_case {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: var(--radius-md);
    gap: 15px;
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
}

.user_referrals_title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: var(--text-primary);
    display: flex;
    align-items: center;
    gap: 10px;
}

.user_referrals_count {
    font-size: 13px;
    font-weight: 600;
    background-color: var(--primary);
    color: #fff;
    padding: 2px 10px;
    border-radius: 12px;
}

.user_referrals_subtitle {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-secondary);
}

.user_referrals_grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
}

.user_referral_item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background-color: var(--bg);
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
    font-size: 13px;
}

.user_referral_name {
    font-weight: 600;
    color: var(--text-primary);
    white-space: nowrap;
}

.user_referral_email {
    color: var(--text-muted);
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    flex: 1 1;
}

.user_referral_delete_user_button {
    color: var(--danger);
    font-weight: 700;
    font-size: 13px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 2px 6px;
    border-radius: var(--radius-sm);
    transition: all var(--transition-fast);
    flex-shrink: 0;
}

.user_referral_delete_user_button:hover {
    background-color: var(--danger-light);
}

.user_referrals_toggle {
    align-self: center;
    background: none;
    border: 1px solid var(--border);
    color: var(--primary);
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    padding: 8px 20px;
    border-radius: var(--radius-sm);
    transition: all var(--transition-fast);
}

.user_referrals_toggle:hover {
    background-color: var(--primary-light);
}
`, "",{"version":3,"sources":["webpack://./src/pages/users/userById/UserSections/UserReferrals/userReferrals.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,2BAA2B;IAC3B,+BAA+B;IAC/B,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,SAAO;AACX;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C","sourcesContent":[".user_referrals_case {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: var(--radius-md);\n    gap: 15px;\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n}\n\n.user_referrals_title {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--text-primary);\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.user_referrals_count {\n    font-size: 13px;\n    font-weight: 600;\n    background-color: var(--primary);\n    color: #fff;\n    padding: 2px 10px;\n    border-radius: 12px;\n}\n\n.user_referrals_subtitle {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--text-secondary);\n}\n\n.user_referrals_grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 8px;\n}\n\n.user_referral_item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 12px;\n    background-color: var(--bg);\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border);\n    font-size: 13px;\n}\n\n.user_referral_name {\n    font-weight: 600;\n    color: var(--text-primary);\n    white-space: nowrap;\n}\n\n.user_referral_email {\n    color: var(--text-muted);\n    font-size: 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    min-width: 0;\n    flex: 1;\n}\n\n.user_referral_delete_user_button {\n    color: var(--danger);\n    font-weight: 700;\n    font-size: 13px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 2px 6px;\n    border-radius: var(--radius-sm);\n    transition: all var(--transition-fast);\n    flex-shrink: 0;\n}\n\n.user_referral_delete_user_button:hover {\n    background-color: var(--danger-light);\n}\n\n.user_referrals_toggle {\n    align-self: center;\n    background: none;\n    border: 1px solid var(--border);\n    color: var(--primary);\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    padding: 8px 20px;\n    border-radius: var(--radius-sm);\n    transition: all var(--transition-fast);\n}\n\n.user_referrals_toggle:hover {\n    background-color: var(--primary-light);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
